const getId = () => {
  const user = JSON.parse(window.localStorage.getItem('user'))
  return user.sub
}

const getAuth = () => {
  const auth = JSON.parse(window.localStorage.getItem('auth_user'))
  return auth
}

const setAuthUser = (user) => {
  window.localStorage.setItem('auth_user', JSON.stringify(user))
}

const getAuthToken = () => {
  const user = JSON.parse(window.localStorage.getItem('auth_user'))
  return { key: 'Authorization', value: `Bearer ${user && user.accessToken ? user.accessToken : ''}` }
}

export {
  getId,
  setAuthUser,
  getAuth,
  getAuthToken
}
